import React from 'react';
import { Layout } from '../../components/Layout';
import { Blocks } from 'lucide-react';

export function BlockTypesPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <Blocks className="h-8 w-8 text-green-400" />
          <h1 className="text-3xl font-bold text-white">Block Types</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2>Core Blocks</h2>
              <p>
                WordPress core blocks are the fundamental building blocks available in the Gutenberg editor. 
                Our generator supports all core blocks with enhanced customization options.
              </p>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <h3 className="text-lg font-semibold mb-2">Text Blocks</h3>
                  <ul className="list-disc list-inside">
                    <li>Paragraph</li>
                    <li>Heading</li>
                    <li>List</li>
                    <li>Quote</li>
                    <li>Preformatted</li>
                  </ul>
                </div>
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <h3 className="text-lg font-semibold mb-2">Media Blocks</h3>
                  <ul className="list-disc list-inside">
                    <li>Image</li>
                    <li>Gallery</li>
                    <li>Video</li>
                    <li>Audio</li>
                    <li>Cover</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2>Layout Blocks</h2>
              <p>
                Layout blocks help you create complex page structures and organize content effectively.
              </p>
              <ul>
                <li>Group</li>
                <li>Columns</li>
                <li>Media & Text</li>
                <li>Spacer</li>
                <li>Separator</li>
              </ul>
            </section>

            <section>
              <h2>Block Attributes</h2>
              <p>
                Each block type supports various attributes that control its appearance and behavior:
              </p>
              <div className="bg-gray-800/50 rounded-lg p-4 mt-4">
                <h3 className="text-lg font-semibold mb-2">Common Attributes</h3>
                <ul className="list-disc list-inside">
                  <li>Alignment</li>
                  <li>Background Color</li>
                  <li>Text Color</li>
                  <li>Font Size</li>
                  <li>Padding & Margin</li>
                  <li>Custom Classes</li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}